import React, { useEffect, useState } from 'react';
import { Trash2 } from 'lucide-react';
import './subdepartmentParent.css';

export default function SubdepartmentParent({ formFields = [], onChange }) {
  const subDepartmentField = formFields.find((field) => field.fieldLabel === 'Sub-department');
  const departmentField = formFields.find((field) => field.fieldLabel === 'Department');
  const subDepartmentOptions = subDepartmentField?.options || ["payrool ","recruitment"];
  const departmentOptions = departmentField?.options || ["hr", "finance"];
  const [parentMappings, setParentMappings] = useState({});

  useEffect(() => {
    const availableSubDepartments = new Set(subDepartmentOptions);

    setParentMappings((currentMappings) =>
      Object.fromEntries(
        Object.entries(currentMappings).filter(([option]) => availableSubDepartments.has(option)),
      ),
    );
  }, [subDepartmentOptions]);

  const updateParentMapping = (option, parent) => {
    setParentMappings((currentMappings) => ({
      ...currentMappings,
      [option]: parent,
    }));
  };

const deleteSubDepartment = (optionToDelete) => {
  if (!subDepartmentField) return;

  const updatedFields = formFields.map((field) => {
    if (field !== subDepartmentField) return field;

    return {
      ...field,
      options: field.options.filter(
        (option) => option !== optionToDelete
      ),
    };
  });

  setParentMappings((currentMappings) => {
    const nextMappings = { ...currentMappings };
    delete nextMappings[optionToDelete];
    return nextMappings;
  });

  onChange?.(updatedFields);
};

  return (
    <aside className="subdepartment-parent" aria-labelledby="subdepartment-parent-title">
      <h2 id="subdepartment-parent-title" className="subdepartment-parent__title">
        Options for: {subDepartmentField?.fieldLabel || 'Sub-department'}
      </h2>
      <p className="subdepartment-parent__description">Define options and set parent.</p>

      {subDepartmentOptions.length ? (
        <div className="subdepartment-parent__table-wrap">
          <table className="subdepartment-parent__table">
            <thead>
              <tr>
                <th scope="col">Option label</th>
                <th scope="col">Parent</th>
                <th scope="col" aria-label="Delete" />
              </tr>
            </thead>
            <tbody>
              {subDepartmentOptions.map((option) => (
                <tr key={option}>
                  <td>{option}</td>
                  <td>
                    <select
                      aria-label={`Parent for ${option}`}
                      value={parentMappings[option] || ''}
                      disabled={!departmentOptions.length}
                      onChange={(event) => updateParentMapping(option, event.target.value)}
                    >
                      <option value="">
                        {departmentOptions.length ? 'Select parent' : 'No department options'}
                      </option>
                      {departmentOptions.map((department) => (
                        <option key={department} value={department}>
                          {department}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <button
                      className="subdepartment-parent__delete"
                      type="button"
                      aria-label={`Delete ${option}`}
                      title={`Delete ${option}`}
                      onClick={() => deleteSubDepartment(option)}
                    >
                      <Trash2 size={14} strokeWidth={1.5} aria-hidden="true" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="subdepartment-parent__empty">No sub-department options added.</p>
      )}
    </aside>
  );
}